import { render, staticRenderFns } from "./order-fee.vue?vue&type=template&id=4be06703"
import script from "./order-fee.vue?vue&type=script&lang=js"
export * from "./order-fee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports